/**
 * Components
 */

import GMap from '../../shared/components/gmap/gmap';
import Hero from './custom/hero';
import MediaGallery from './overwrites/shared/media-gallery';
import Table from './overwrites/shared/table/table';

// ------
// Public
// ------

const components = () => {
	Hero.init();
	MediaGallery.init();
	Table.makeScrollable();

	// const gMapAllowed = (typeof window.ifabCookieConsent !== 'undefined') ? window.ifabCookieConsent.getConsent('googlemaps') : true;
	//
	// if (gMapAllowed && typeof window.pageInstance.settings.maps.google.id) {
	GMap.init(null, {
		apiKey  : window.pageInstance.settings.maps.google.id,
		settings: {
			// Siehe google-maps.js -> DEFAULTS
			map: {
				zoom: 14
			}
		}
	});
	// }
};

// Export
export default components;
